
import axios from '@/axios.js'

export default {
  addTestimonial ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      const testimonial = new FormData()
      testimonial.append('title', obj.title)
      testimonial.append('body', obj.body)
      testimonial.append('file', obj.imageURL)
      axios.post('/testimonials/add', testimonial)
        .then((response) => {
          commit('ADD_TESTIMONIAL', Object.assign(response.data.data[0])) 
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTestimonials ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/testimonials')
        .then((response) => {
          commit('SET_TESTIMONIAL', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // fetchEventLabels({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     axios.get("/api/apps/calendar/labels")
  //       .then((response) => {
  //         commit('SET_LABELS', response.data)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  updateTestimonial ({ dispatch }, obj) {
    return new Promise((resolve, reject) => {
      const testimonial = new FormData()
      testimonial.append('title', obj.title)
      testimonial.append('body', obj.body)
      testimonial.append('file', obj.imageURL)
      axios.put(`/testimonials/update/${obj.id}`, testimonial)
        .then((response) => {
          // commit('UPDATE_TESTIMONIAL', response.data)
          dispatch('fetchTestimonials')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeTestimonial ({ commit }, testimonialId) {
    return new Promise((resolve, reject) => {
      axios.delete(`testimonials/remove/${testimonialId}`)
        .then((response) => {
          commit('REMOVE_TESTIMONIAL', testimonialId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
  // eventDragged({ commit }, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(`/api/apps/calendar/event/dragged/${payload.event.id}`, {payload: payload})
  //       .then((response) => {

  //         // Convert Date String to Date Object
  //         let event = response.data
  //         event.startDate = new Date(event.startDate)
  //         event.endDate = new Date(event.endDate)

  //         commit('UPDATE_EVENT', event)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
}
